// types
import { IfrPlan } from '../../../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// mui
import { Grid, Paper, Typography } from '@mui/material';

// ui
import { Currency } from '../../../../ui/Currency/Currency';
import { UserAvatarModified } from '../../../../ui/UserAvatarModified/UserAvatarModified';

// theme
import { theme } from '../../../../../theme';

// utils
import { formatDate } from '../../../../../utils/dates';

// props
export interface DetailsProps {
	ifrPlan: IfrPlan | null;
}

export const Details = ({ ifrPlan }: DetailsProps) => {
	// hooks
	const { t } = useTranslation();

	// vars
	const data = [];

	if (ifrPlan) {
		data.push({
			label: t('fiscalYearStart'),
			value: formatDate({ date: ifrPlan.dateFiscalYearStart }),
		});

		data.push({
			label: t('fiscalYearEnd'),
			value: formatDate({ date: ifrPlan.dateFiscalYearEnd }),
		});

		data.push({
			label: t('created'),
			value: (
				<UserAvatarModified
					date={ifrPlan.created}
					ifrPlan={ifrPlan}
					variant="compact"
					activityTypes={['IFR_PLAN_CREATED', 'IFR_PLAN_VERSION_CREATED']}
				/>
			),
		});

		data.push({
			label: t('modified'),
			value: (
				<UserAvatarModified
					date={ifrPlan.modified || ifrPlan.created}
					ifrPlan={ifrPlan}
					variant="compact"
					activityTypes={['IFR_PLAN_UPDATED', 'IFR_PLAN_VERSION_UPDATED']}
				/>
			),
		});

		data.push({
			label: t('currency'),
			value: <Currency currency={ifrPlan.currency} TypographyProps={{ variant: 'caption' }} />,
		});
	}

	return (
		<Paper
			sx={{
				padding: theme.spacing(2),
				width: '100%',
				height: {
					xs: '100%',
					lg: `calc(100% + ${theme.spacing(2)})`,
				},
			}}>
			{ifrPlan && (
				<Grid
					container
					direction="column"
					justifyContent="space-between"
					sx={{ flex: 1, height: '100%' }}>
					{data.map((item, i) => (
						<Grid item key={`details-${i}-${item.value}`} sx={{ width: '100%' }}>
							<Grid container justifyContent="space-between" spacing={1}>
								<Grid item>
									<Typography color="text.secondary" variant="caption">
										{item.label}
									</Typography>
								</Grid>
								<Grid item>
									<Typography fontWeight={600} variant="caption">
										{item.value}
									</Typography>
								</Grid>
							</Grid>
						</Grid>
					))}
				</Grid>
			)}
		</Paper>
	);
};
